import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';
import { encryptValue, decryptValue } from '../../util/gameUtils';

export default class Game {
  constructor() {
    document
      .querySelector('#game_header #volumeBtn')
      .addEventListener('mousedown', this.updateVolume.bind(this));
    document
      .querySelector('#game_header #volumeBtn')
      .addEventListener('touchstart', this.updateVolume.bind(this));

    // encrypted game state
    this.gameStartTime = Date.now();
    this.totalGameTime = 0;
    this.totalScore = 0;
    this.totalTime = 0;

    // console.log("1");
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents.bind(this));

    Global.totalGoals = 0;
    this.hattrickCheck = 0;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'start_time':
        this.startTimer();
        break;
      case 'goal':
        this.updateGoal();
        break;
      case 'defend':
        this.showMiss();
        break;
      case 'stop_timer':
        this.stopTimer();
        break;
    }
  }

  updateGameData(update, caseType) {
    if (this._updating) return;
    this._updating = true;
    // console.log("updateGameData called");
    // Decrypt key2 to retrieve game state
    // const meta = JSON.parse(decryptValue(Global.key2));
    const currentTime = Date.now();
    this.totalTime = Math.floor((currentTime - this.gameStartTime) / 1000);
    this.totalGameTime = Math.floor((currentTime - this.gameStartTime) / 1000);
    // Retrieve current score
    // this.totalScore = parseInt(decryptValue(Global.key1), 10);
    if (update) {
      this.totalScore = Global.totalGoals;
    }
    // Global.key1 = encryptValue(this.totalScore); // Encrypt updated score

    // console.log("After encryption, key1:", decryptValue(Global.key1));
    // Store goal event
    // meta.t2.push({
    //   gt: this.totalTime, // Game elapsed time
    //   ct: currentTime, // Current timestamp
    //   ts: this.totalScore, // Total score
    //   p: caseType === 'goal' ? 1 : 0,
    // });

    // Global.key2 = encryptValue(JSON.stringify(meta));
    // console.log("After encryption, key2:", decryptValue(Global.key2));

    this._updating = false;
  }

  showScreen(data) {
    if (data['screenKey'] !== 'Game') return false;

    // console.log("2");
    // Global.key1 = encryptValue(0);
    // Global.key2 = encryptValue(
    //   JSON.stringify({
    //     t1: Date.now(),
    //     t2: [],
    //   })
    // );
    Global.totalGoals = 0;
    document.querySelector('#game_header .score_label').innerHTML =
      Global.totalGoals;

    document.querySelector('#game_header').classList.add('active');
    document.querySelector('.goal_popup').classList.add('active');
    document.querySelector('.hattrick_popup').classList.add('active');
    document.querySelector('.miss_popup').classList.add('active');
  }
  stopTimer() {
    this.timerInterval && clearInterval(this.timerInterval);
    this.hattrickCheck = 0;
  }
  startTimer() {
    this.hattrickCheck = 0;
    this.startTime = Date.now();
    let elapsed = {
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    };

    this.timerInterval = setInterval(() => {
      let now = Date.now();
      let timeDiff = 1000 * 60 * 3 - (now - this.startTime);

      if (timeDiff < 10) {
        timeDiff = 0;
      }
      elapsed.minutes = Math.floor(timeDiff / 60000);
      elapsed.seconds = Math.floor((timeDiff % 60000) / 1000);
      elapsed.milliseconds = Math.floor((timeDiff % 1000) / 10);

      Global[`level${Global.gameLevel}Time`] =
        elapsed.minutes * 60 + elapsed.seconds + elapsed.milliseconds / 1000; //.toFixed(2)
      document.querySelector('.time_sec .info').innerHTML = `${
        elapsed.minutes < 10 ? '0' : ''
      }${elapsed.minutes}:${elapsed.seconds < 10 ? '0' : ''}${
        elapsed.seconds
      }:${elapsed.milliseconds < 10 ? '0' : ''}${elapsed.milliseconds}`;

      Global.timeTaken = now - this.startTime;
      if (timeDiff <= 0) {
        this.events.dispatchEvent({
          type: 'GAME_EVENTS',
          message: {
            event_type: 'game_over',
            data: {},
          },
        });
      }
    }, 10);
  }
  updateGoal() {
    Global.totalGoals++;
    this.hattrickCheck++;
    this.updateGameData(true, 'goal');
    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: {
        event_type: 'play_sound',
        data: {
          sndKey: 'goal',
        },
      },
    });
    if (this.hattrickCheck >= 3) {
      this.hattrickCheck = 0;
      document.querySelector('.hattrick_popup').classList.add('active2');
    } else {
      document.querySelector('.goal_popup').classList.add('active2');
    }
    document.querySelector('#game_header .score_label').innerHTML =
      Global.totalGoals;

    setTimeout(() => {
      document.querySelector('.goal_popup').classList.remove('active2');
      document.querySelector('.hattrick_popup').classList.remove('active2');
    }, 1500);
  }
  showMiss() {
    this.hattrickCheck = 0;
    this.updateGameData(true, 'defend');

    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: {
        event_type: 'play_sound',
        data: {
          sndKey: 'miss',
        },
      },
    });
    document.querySelector('.miss_popup').classList.add('active2');
    setTimeout(() => {
      document.querySelector('.miss_popup').classList.remove('active2');
    }, 1500);
  }

  updateVolume(v) {
    v.preventDefault();
    v.stopPropagation();
    v.stopImmediatePropagation();

    Global.soundEnabled = !Global.soundEnabled;
    if (Global.soundEnabled) {
      document
        .querySelector('#game_header #volumeBtn')
        .classList.remove('active');
      this.events.dispatchEvent({
        type: 'SOUND_EVENTS',
        message: {
          event_type: 'play_sound',
          data: {
            sndKey: 'crowd',
          },
        },
      });
    } else {
      document.querySelector('#game_header #volumeBtn').classList.add('active');
      this.events.dispatchEvent({
        type: 'SOUND_EVENTS',
        message: {
          event_type: 'stop_sound',
          data: {
            sndKey: 'crowd',
          },
        },
      });
    }
  }
}
